module.exports = __webpack_public_path__ + "files/d1c1843f111093aebac919fc44a8d870.png";